// extracted by mini-css-extract-plugin
export default {"fullscreen":"page-content-module--fullscreen--d1657","dark":"page-content-module--dark--e21df","primary":"page-content-module--primary--1f6fd"};